import type { AppNotification } from '@core/entities/AppNotification';
import type { NotificationRepository } from '@core/repositories/NotificationRepository';
import { httpClient } from '@infrastructure/http/httpClient';
import { toAppError } from '@infrastructure/http/errorMapper';

interface NotificationResponse {
  id: string;
  type: string | null;
  data: Record<string, unknown>;
  readAt: string | null;
  createdAt: string;
}

const toAppNotification = (response: NotificationResponse): AppNotification => ({
  id: response.id,
  type: response.type,
  data: response.data,
  readAt: response.readAt,
  createdAt: response.createdAt,
});

export class NotificationRepositoryImpl implements NotificationRepository {
  async list(): Promise<AppNotification[]> {
    try {
      const response = await httpClient.get<{ data: NotificationResponse[] }>('/notifications');
      return response.data.data.map(toAppNotification);
    } catch (error) {
      throw toAppError(error);
    }
  }

  async markRead(id: string): Promise<void> {
    try {
      await httpClient.post(`/notifications/${id}/read`);
    } catch (error) {
      throw toAppError(error);
    }
  }

  async markAllRead(): Promise<void> {
    try {
      await httpClient.post('/notifications/read-all');
    } catch (error) {
      throw toAppError(error);
    }
  }
}
